import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import DashboardG from './DashboardG';
import MenuPrincipal from './MenuPrincipal'; // Importando a nova tela
import EnquetesScreen from './enquetes';
import CondecoracoesScreen from './condecoracoes';
import MapaAtividadeScreen from './mapaAtividade';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/menu" element={<MenuPrincipal />} />
        <Route path="/dashboard" element={<DashboardG />} />
        <Route path="/enquetes" element={<EnquetesScreen />} />
        <Route path="/condecoracoes" element={<CondecoracoesScreen />} />
        <Route path="/mapa-Atividade" element={<MapaAtividadeScreen />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;